import { useLocalizedHref } from '@/libraries/web-framework/src/localization/use-localized-href';
import { getWacIntegrationUrl } from '@/utils/urls.ts';

import { type ChoiceValue } from './loom-choice-variant-a';

// Canonical continue URLs for the Loom Land opt-in choice CTAs.
//  - teamwork-collection: provision the Teamwork Collection (premium).
//  - loom-only: today's Loom-only flow — identical to the control-cohort
//    redirect on the choose page.
const TWC_SIGNUP_PATH = '/try/cloud/signup?bundle=teamwork-collection&edition=premium';
const LOOM_SIGNUP_PATH = '/try/cloud/signup?bundle=loom&edition=premium&application=wac--loom';

/**
 * Resolves absolute, localized continue URLs for the opt-in choice CTAs.
 *
 * The URLs must be absolute WAC URLs: they drive a top-level navigation into the
 * signup/provisioning flow (`window.location.assign`), and `useLocalizedHref`
 * yields a locale-prefixed path which we make absolute via getWacIntegrationUrl()
 * (matching the jira-plus opt-in pattern).
 */
export const useChoiceRedirect = (): ((choice: ChoiceValue) => void) => {
	const twcHref = useLocalizedHref(TWC_SIGNUP_PATH);
	const loomHref = useLocalizedHref(LOOM_SIGNUP_PATH);

	return (choice: ChoiceValue) => {
		const path = choice === 'teamwork-collection' ? twcHref : loomHref;
		window.location.assign(`${getWacIntegrationUrl()}${path}`);
	};
};
